var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-tabs",
        {
          attrs: { grow: "", "slider-color": "primary", "slider-size": "3" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "v-tab",
            { key: "groups" },
            [
              _c("v-icon", { attrs: { left: "", size: "20" } }, [
                _vm._v("mdi-folder-multiple"),
              ]),
              _vm._v(" Groups "),
            ],
            1
          ),
          _c(
            "v-tab",
            { key: "branches" },
            [
              _c("v-icon", { attrs: { left: "", size: "20" } }, [
                _vm._v("mdi-source-branch"),
              ]),
              _vm._v(" Branches "),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "v-tab-item",
            {
              key: "groups",
              attrs: {
                transition: "fade-transition",
                "reverse-transition": "fade-transition",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-4", attrs: { flat: "" } },
                [
                  _vm.loading
                    ? _c(
                        "v-overlay",
                        { attrs: { absolute: "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "d-flex align-center mb-4" },
                    [
                      _c(
                        "v-chip",
                        {
                          attrs: { small: "", color: "primary", outlined: "" },
                        },
                        [_vm._v(_vm._s(_vm.allGroups.length) + " groups")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            disabled:
                              _vm.selectedGroupsForDeletion.length === 0 ||
                              !_vm.ifCanEditConfigTag(),
                            color: "error",
                            small: "",
                          },
                          on: { click: _vm.bulkRemoveGroups },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-delete"),
                          ]),
                          _vm._v(
                            " Remove Selected (" +
                              _vm._s(_vm.selectedGroupsForDeletion.length) +
                              ") "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: !_vm.ifCanEditConfigTag(),
                            color: "primary",
                            small: "",
                          },
                          on: { click: _vm.openAddGroupDialog },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-plus"),
                          ]),
                          _vm._v(" Add Group "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    { staticClass: "rounded-lg", attrs: { outlined: "" } },
                    [
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item-group",
                            {
                              attrs: { multiple: "" },
                              model: {
                                value: _vm.selectedGroupsForDeletion,
                                callback: function ($$v) {
                                  _vm.selectedGroupsForDeletion = $$v
                                },
                                expression: "selectedGroupsForDeletion",
                              },
                            },
                            _vm._l(_vm.allGroups, function (groupInfo) {
                              return _c("v-list-item", {
                                key: groupInfo.uniqueKey,
                                attrs: {
                                  value: groupInfo,
                                  disabled: !_vm.ifCanEditConfigTag(),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ active }) {
                                        return [
                                          _c(
                                            "v-list-item-action",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  "input-value": active,
                                                  color: "primary",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        color: "blue lighten-4",
                                                        "text-color":
                                                          "blue--text",
                                                        "x-small": "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            groupInfo.branch
                                                              .name
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        color:
                                                          "orange lighten-4",
                                                        "text-color":
                                                          "orange--text",
                                                        "x-small": "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            groupInfo.group.name
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      staticClass: "ml-2",
                                                      attrs: {
                                                        color:
                                                          groupInfo.configsCount >
                                                          0
                                                            ? "green lighten-4"
                                                            : "grey lighten-3",
                                                        "text-color":
                                                          groupInfo.configsCount >
                                                          0
                                                            ? "green--text"
                                                            : "grey--text",
                                                        "x-small": "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            groupInfo.configsCount
                                                          ) +
                                                          " configs "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-action",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      !_vm.ifCanEditConfigTag(),
                                                    icon: "",
                                                    "x-small": "",
                                                    color: "error",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.removeSingleGroup(
                                                        groupInfo
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { small: "" } },
                                                    [_vm._v("mdi-delete")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "500px" },
                      model: {
                        value: _vm.addGroupDialog,
                        callback: function ($$v) {
                          _vm.addGroupDialog = $$v
                        },
                        expression: "addGroupDialog",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [
                            _c("span", { staticClass: "headline" }, [
                              _vm._v("Add Group to Branch"),
                            ]),
                          ]),
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.branches,
                                              "item-text": "name",
                                              "item-value": "uid",
                                              label: "Select Branch",
                                              outlined: "",
                                              "return-object": "",
                                              dense: "",
                                            },
                                            model: {
                                              value:
                                                _vm.selectedBranchForNewGroup,
                                              callback: function ($$v) {
                                                _vm.selectedBranchForNewGroup =
                                                  $$v
                                              },
                                              expression:
                                                "selectedBranchForNewGroup",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm.orphanedGroupNames.length > 0
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "caption grey--text mb-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "Unassigned groups (click to use):"
                                                  ),
                                                ]
                                              ),
                                              _vm._l(
                                                _vm.orphanedGroupNames,
                                                function (name) {
                                                  return _c(
                                                    "v-chip",
                                                    {
                                                      key: name,
                                                      staticClass: "mr-1 mb-1",
                                                      attrs: {
                                                        small: "",
                                                        color:
                                                          "orange lighten-4",
                                                        "text-color":
                                                          "orange--text",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.newGroupName =
                                                            name
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " + _vm._s(name) + " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "ascii-only",
                                                rawName: "v-ascii-only",
                                              },
                                            ],
                                            attrs: {
                                              label: "Group Name",
                                              outlined: "",
                                              dense: "",
                                            },
                                            model: {
                                              value: _vm.newGroupName,
                                              callback: function ($$v) {
                                                _vm.newGroupName = $$v
                                              },
                                              expression: "newGroupName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "blue darken-1", text: "" },
                                  on: { click: _vm.closeAddGroupDialog },
                                },
                                [_vm._v("Cancel")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "blue darken-1", text: "" },
                                  on: { click: _vm.saveNewGroup },
                                },
                                [_vm._v("Add")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-tab-item",
            {
              key: "branches",
              attrs: {
                transition: "fade-transition",
                "reverse-transition": "fade-transition",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-4", attrs: { flat: "" } },
                [_c("c-branch-table")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }